import { makeStyles } from '@material-ui/core/styles';
import { themeColor } from '../../../mui-theme';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useStyles = makeStyles(_theme => ({
  root: {
    flexGrow: 1,
  },
  gridcontaineruser: {
    backgroundColor: themeColor.lightBackground,
    minHeight: '100vh',
  },
  deviceList: {
    textAlign: 'left',
    width: 'fit-content',
    margin: '0 auto',
    letterSpacing: '1px',
    wordSpacing: '1.5px',
  },
}));
